import {FC} from 'react';
import {RootState} from '../../store/store';
import {useAppSelector} from '../../store/hooks';
import {ReactComponent as Logo} from '../../assets/images/header-planet.svg';
import {NavBar} from '../navbar/NavBar';
import {UserMenu} from './UserMenu';
import Notifications from './notifications/Notifications';
import Tenants from './Tenants';
import {Link} from 'react-router-dom';

export const Header : FC = () => {
  const {title} = useAppSelector((state: RootState) => state.navMenu);

  return (
    <header className="header">
      <div className="container">
        <div className="header_left-side">
          <NavBar />
          <Link
            className="header_logo-and-company-name"
            to={'/'}
          >
            <Logo className="app-logo"/>
            <h5 className="header_company-name">FlowPatterns</h5>
          </Link>
          <h4 className="header_tenant-name">Seneca</h4>
        </div>

        <h5 className="header_title">{title}</h5>

        <div className="right-side no-margin-right">
          <Tenants />
          <div className="display-flex">
            <Notifications />
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
};
